import { DrugSearchResMock } from '../../../../../types/drug.type'

/** A picker option that may carry a stock flag (drug names from `drugAction`, strengths from the search). */
export type StockOption = { label: string; value: string; inStock?: boolean }

/** Small pill shown next to an option whose drug or strength has pharmacy stock. */
export const InStockPill = () => (
  <span className="ml-2 inline-flex shrink-0 items-center rounded-full border border-[#8EE6AA] bg-[#D9FBE3] px-2 py-px text-[11px] leading-4 text-[#008C35]">
    In stock
  </span>
)

/** react-select `formatOptionLabel`: the label, plus an "In stock" pill when the option says so. */
export const formatStockOptionLabel = (option: StockOption) => (
  <span className="inline-flex items-center">
    {option.label}
    {option.inStock ? <InStockPill /> : null}
  </span>
)

/**
 * Strength options for the chosen drug + form, as the search returns them (one per strength
 * combination, in order). A combination is in stock when every strength in it is.
 */
export const strengthOptionsFromSearch = (hits: DrugSearchResMock[] | undefined): StockOption[] =>
  (hits ?? []).flatMap(
    drug =>
      drug?.available_strengths?.map(combination => {
        const entries = combination ?? []
        const label = entries.map(s => s?.strength).join('/')
        const inStock = entries.length > 0 && entries.every(s => !!s?.in_stock)
        return { inStock, label, value: label }
      }) ?? []
  )
